import styled from 'styled-components';

interface TrackProps {
	$height: string;
	$rounded: boolean;
	$barBackground?: string;
	$width?: number;
}

interface FillProps {
	$percent: number;
	$height: string;
	$barColor?: string;
}

export const Track = styled.div<TrackProps>`
	background: ${({ $barBackground }) => ($barBackground ? $barBackground : '#d1d1d1')};
	height: ${({ $height }) => $height};
	${({ $rounded }) => $rounded && 'border-radius: 9999px;'}
	overflow: hidden;
	width: 100%;
	flex-grow: 1;
`;

export const Fill = styled.div<FillProps>`
	width: ${({ $percent }) => $percent}%;
	height: ${({ $height }) => $height};
	background: ${({ $barColor }) => ($barColor ? $barColor : '#00a871')};
	transition: width 0.3s ease;
`;
